module.exports = __webpack_public_path__ + "img/resultados-from-excel.faf579d4.png";